
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-iYQeCzEYFbKjA/T2uDLTpkwGzCiq6soy8tYaI1GyVh/UjpbCx/TYkiZhlZB6+fzT" crossorigin="anonymous">
<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" rel="stylesheet"/>
<link href="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/css/flag-icon.min.css" rel="stylesheet"/>
    
    <!-- slider_area_start -->
    <div class="slider_area welcome-area wow fadeInUp" id="goToTop">
        
        <div class="single_slider  d-flex align-items-center slider_bg_1">

            <!-- <app-hamburger1 style="position:absolute;top:0px;"></app-hamburger1> -->
            <!-- <div id="particles-js"></div> -->
            <div class="container">
                
                <div class="row align-items-center justify-content-center">
                     
                    <div *ngIf="showAccountLogin" class="col-lg-7 col-md-6 d-block d-sm-none" >
                        <div style="float: right; padding-top: 25px;" class="sldier_btn"  
                        data-aos="fade-up" data-aos-duration="1500"> 
                            <a  style="cursor:pointer; font-size: 10px;" class="boxed-btn4" (click)="changeLanguage()">{{language}}</a>
                        </div>
                    </div>
                    <div *ngIf="!showAccountLogin"  class="col-lg-7 col-md-6 phone_num d-block d-sm-none" data-aos="fade-up" data-aos-duration="1500" 
                          style="cursor:pointer; font-size: 24px; padding-left: {{paddinLeftSizeForLogOut}}px; padding-top: 25px;" (click)="openModal(templateLogout)" >
                        <a> <i class="glyphicon glyphicon-off text-danger"></i></a>
                     </div>
                    <div class="col-lg-7 col-md-6 d-none d-sm-block" >
                        <div class="slider_text">
                            <h3 class="wow fadeInRight d-none d-sm-block" data-wow-duration="1s" data-wow-delay=".1s"  i18n>Send money without paying fees</h3>
                            <div class="sldier_btn" data-aos="fade-up" data-aos-duration="1500">
                                <a (click)="HowItWorks()" style="cursor:pointer;" class="boxed-btn3"  i18n>How it Works</a>
                            </div>
                        </div>
                    </div>



                    <div class="container d-block d-sm-none">
                        <div class="row" style="padding-top: 50px;">

                            <div class="col" >
                                <div class="slider_text">
                                    <h3 class="wow fadeInRight d-none d-sm-block" data-wow-duration="1s" data-wow-delay=".1s"  i18n>Send money without paying fees</h3>
                                    <div class="sldier_btn" data-aos="fade-up" data-aos-duration="1500">
                                        <a (click)="HowItWorks()" style="cursor:pointer;" class="boxed-btn10"  i18n>How it Works</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="slider_text">
                                    <h3 class="wow fadeInRight d-none d-sm-block" data-wow-duration="1s" data-wow-delay=".1s"  i18n>Send money without paying fees</h3>
                                    <div class="sldier_btn" data-aos="fade-up" data-aos-duration="1500">
                                        <a (click)="openModalCreerCompte(template1)"  style="cursor:pointer; float: right;" class="boxed-btn10"  i18n>Create account</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="col-lg-5 col-md-6">
                        <div class="payment_form white-bg wow fadeInDown" data-wow-duration="1.2s" data-wow-delay=".2s">
                            <div class="d-flex justify-content-center" (click)="alerte()">
                                    <ng-multiselect-dropdown
                                    class="d-flex justify-content-center"
                                    
                                    [settings]="dropdownSettings"
                                    [data]="dropdownList_"
                                    [(ngModel)]="selectedItems"
                                    (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)"
                                    (onDeSelect)="onItemDeSelect($event)"
                                    >
                                    </ng-multiselect-dropdown>
                                    <!-- <select id="selectedFlag" (ngModelChange)="changeFlag()">
                                        <option value="CA" checked>CANADA</option>
                                        <option value="USA">USA</option>
                                        <option value="FR">FRANCE</option>
                                    </select> -->
                            </div>
                            <div class="info text-center">
                                                                <!-- large screen -->
                                                                <h4 class="d-none d-sm-block" i18n>How much do you want to send ?</h4>
                                                                <!-- / large screen -->
                                                                <!-- mobile screen -->
                                                                <h4 *ngIf="getPlatform()" class="d-block d-sm-none hidden-on-lgScreen" style="white-space: nowrap;" i18n>How much do you want to send ?</h4>
                                                                <h4 *ngIf="!getPlatform()" class="d-block d-sm-none hidden-on-lgScreen"  i18n>How much do you want to send ?</h4>
                                                                <!-- / mobile screen -->
                                <p *ngIf="!amountToSendError"  style="animation-duration:2s; animation-delay:2s; animation-iteration-count:infinite;"  i18n>You have to pay: <strong>$0</strong> for fees</p>
                                <p *ngIf="amountToSendError" class="text-danger d-none d-sm-block" data-aos="fade-right" data-aos-duration="1500"  i18n>Amount need to be from 5$ to 999$ !</p>
                                <p *ngIf="amountToSendError" class="text-danger d-block d-sm-none" data-aos="fade-right" data-aos-duration="1500"  i18n>Amount need to be from 5$ to 999$ !</p>
                                <!-- <p>We provide online instant cash loans with quick</p> -->
                                <div *ngIf="showRate"  class="col-lg-12 justify-content-center text-center" style="padding-top: 25px">
                                    <h3  i18n>RATE : 1  {{currencyToSend}} = <strong>{{rate}} {{currencyToReceive}}</strong></h3>
                                </div>
                                <div *ngIf="showRateSpinner"  class="dots-bars-2" style="margin: auto;color:#FFD700;"></div>
                            </div>
                            <div class="form">
                                <div class="row">
                                    <div class="col-lg-12">   
                                        <label class="form-label" for="formControlLg"  i18n>AMOUNT TO SEND</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                              <span *ngIf="showCanadaCmr" class="input-group-text" data-aos="fade-up"  ><strong>$CA</strong></span>
                                              <span *ngIf="showCmrCanada" class="input-group-text" data-aos="fade-up"  ><strong>XAF</strong></span>
                                            </div>
                                            <input type="number" id="sendInput" (keyup)=getVal($event) (click)=getVal($event) class="form-control" aria-label="Amount (to the nearest dollar)"
                                            style="height: 50px; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px;font-size:16px;">
                                            <div class="input-group-append">
                                              <span class="input-group-text">.00</span>
                                            </div>
                                            <i *ngIf="showCanadaCmr" class="{{recipientFlag}} w-25 " data-aos="fade-up"></i>
                                            <i *ngIf="showCmrCanada" class="{{receiverFlag}} w-25 " data-aos="fade-up"></i>
                                          </div>
                                          
                                    </div>
                                    
                                    <i (click)="changeCurrency()" class="glyphicon glyphicon-sort justify-content-center text-center"   style="font-size:24px;color:#FFD700;cursor:pointer;"></i>
                
                                    <div class="col-lg-12">
                                       
                                        <label class="form-label" for="formControlLg"  i18n>AMOUNT TO BE RECEIVED</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                              <span *ngIf="showCanadaCmr" class="input-group-text" data-aos="fade-down"  ><strong>XAF</strong></span>
                                              <span *ngIf="showCmrCanada" class="input-group-text" data-aos="fade-down"  ><strong>$CA</strong></span>
                                            </div>
                                            <input disabled id="receiveInput"  type="text" class="form-control" aria-label="Amount (to the nearest dollar)"
                                            style="height: 50px; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; font-weight: bold; font-size:24px;">
                                            <div class="input-group-append">
                                              <span class="input-group-text">.00</span>
                                            </div>
                                            <i *ngIf="showCanadaCmr" class="{{receiverFlag}} w-25 " data-aos="fade-down"></i>
                                            <i *ngIf="showCmrCanada" class="{{recipientFlag}} w-25 " data-aos="fade-down"></i>
                                          </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="submit_btn">
                                <button class="boxed-btn3" (click)="redirectOnMobileApps()"  type="submit"  i18n>Continue</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <!-- slider_area_end -->

    <!-- service_area_start  -->
    <div class="service_area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section_title text-center mb-90">
                        <span class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s"></span>
                        <h3 class="wow fadeInUp"  data-aos="fade-up" data-aos-offset="500" data-aos-duration="500"  i18n>What we offer for you</h3>
                        <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s"  i18n>We provide online instant transfert with quick approval that suit your term</p>
                    </div>
                </div>
            </div>
            
            <div class="row d-none d-sm-block">
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInLeft" data-wow-duration="1.2s" data-wow-delay=".5s" data-aos="fade-right" data-aos-offset="500"
                    data-aos-duration="1500">
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_1.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>Home Loan</span>
                            <h3  i18n>$3000-$10000</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" data-aos="zoom-in">
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_2.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>car Loan</span>
                            <h3  >$30-$100</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInRight" data-wow-duration="1.2s" data-wow-delay=".5s" data-aos="fade-left" 
                    data-aos-offset="500"
                    data-aos-duration="1500"> 
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_3.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>Training</span>
                            <h3  >$300-$1000</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-block d-sm-none">
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInLeft" data-wow-duration="1.2s" data-wow-delay=".5s" >
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_1.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>Home Loan</span>
                            <h3  >$30-$100</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" >
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_2.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>car Loan</span>
                            <h3  >$30-$100</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single_service wow fadeInRight" data-wow-duration="1.2s" data-wow-delay=".5s" > 
                        <div class="service_icon_wrap text-center">
                            <div class="service_icon ">
                                <img src="./../../../assets/img/svg_icon/service_3.png" alt="">
                            </div>
                        </div>
                        <div class="info text-center">
                            <span  i18n>Training</span>
                            <h3  >$30-$1000</h3>
                        </div>
                        <div class="service_content">
                            <ul>
                                <li  i18n> Borrow - $350 over 3 months </li>
                                <li  i18n> Interest rate - 292% pa fixed</li>
                                <li  i18n>Total amount payable - $525.12</li>
                                <li  i18n>Representative - 1,286% APR</li>
                            </ul>
                            <div class="apply_btn">
                                <button class="boxed-btn3 submitZoom" type="submit" (click)="apply()"  i18n>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- service_area_end  -->
    
    <!-- about_area_start  -->
    <div class="about_area d-none d-sm-block">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-offset="250" data-aos-duration="1500">
                    <div class="about_img wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                        <img class="about" alt="">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-offset="250" data-aos-duration="1500">
                    <div class="about_info pl-68">
                        <div class="section_title wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".3s">
                            <h3  data-aos="fade-up" data-aos-offset="500" data-aos-duration="500" i18n>Why Choose Us?</h3>
                        </div>
                        <p class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s"  i18n>Transfer Money easily in a Secure Way.</p>
                        <div class="about_list">
                            <ul>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s"  i18n>Customer service : We're here to help that's why our service is available 24/7.</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".6s"  i18n>Rapid : Your money arrives in minutes.</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".7s"  i18n>Secured : You can send money directly to a mobile wallet</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".9s"  i18n>Up to date : Use our system to track the status of your transfer.</li>
                            </ul>
                        </div>
                        <div class="about_btn wow fadeInRight" data-wow-duration="1.3s" data-wow-delay=".5s">
                            <a class="boxed-btn3" (click)="About()" style="cursor:pointer;"  i18n>About Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_area d-block d-sm-none">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="about_img wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                        <img src="./../../../assets/img/about/about.png" alt="">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="about_info pl-68">
                        <div class="section_title wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".3s">
                            <h3  data-aos="fade-up" data-aos-offset="500" data-aos-duration="500"  i18n>Why Choose Us?</h3>
                        </div>
                        <p class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s"  i18n>Transfer Money easily in a Secure Way.</p>
                        <div class="about_list">
                            <ul>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s"  i18n>Customer service : We're here to help that's why our service is available 24/7.</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".6s"  i18n>Rapid : Your money arrives in minutes.</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".7s"  i18n>Secured : You can send money directly to a mobile wallet</li>
                                <li class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".9s"  i18n>Up to date : Use our system to track the status of your transfer.</li>
                            </ul>
                        </div>
                        <div class="about_btn wow fadeInRight" data-wow-duration="1.3s" data-wow-delay=".5s">
                            <a class="boxed-btn3" (click)="about()" style="cursor:pointer;"  i18n>About Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- about_area_end  -->

    <div class="works_area ">
        <div class="container">
            <div class="row" >
                <div class="col-lg-12">
                    <div class="section_title text-center mb-90">
                        <span class="wow lightSpeedIn" data-wow-duration="1s" data-wow-delay=".1s"></span>
                        <h3 class="wow fadeInUp"  data-aos="fade-up" data-aos-offset="500" data-aos-duration="500" id="HowItWorks"  i18n>How it Works</h3>
                        <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s"  i18n>We provide online instant transfert with quick approval that suit your term</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4">
                    <div class="single_works">
                        <span data-aos="fade-up" data-aos-offset="500" data-aos-duration="500">
                            01
                        </span>
                        <h3  i18n>Make your transaction</h3>
                        <p  i18n>Enter The Amount In The Receiver’s Or Beneficiary’s Currency.
                            Enter The Sender And Receiver’s Information.
                            Choose A Method Of Delivery.
                            Submit The Form.
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single_works">
                        <span  data-aos="fade-up" data-aos-offset="500" data-aos-duration="1000">
                            02
                        </span>
                        <h3  i18n>Pay the amount to send</h3>
                        <p  i18n>Via Interac E-Transfer.
                            We're Integrated With All Canadian Banks For Free Interac E-Transfer.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single_works">
                        <span  data-aos="fade-up" data-aos-offset="500" data-aos-duration="1500">
                            03
                        </span>
                        <h3  i18n>Receive the money</h3>
                        <p  i18n>Track Your Transaction Using The Code Provided.
                            Both You And Your Recipient Can Be Notified Of Funds Transfer.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="works_area d-block d-sm-none">
        <div class="container">
            <div class="row" >
                <div class="col-lg-12">
                    <div class="section_title text-center mb-90">
                        <span class="wow lightSpeedIn" data-wow-duration="1s" data-wow-delay=".1s"></span>
                        <h3 class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s"  i18n>How it Works</h3>
                        <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s"  i18n>We provide online instant transfert with quick approval that suit your term</p>
                    </div>
                </div>
            </div>
            <div class="row" id="HowItWorksXs">
                <div class="col-md-6 col-lg-4">
                    <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                        <span>
                            01
                        </span>
                        <h3  i18n>Make your transaction</h3>
                        <p  i18n>Enter The Amount In The Receiver’s Or Beneficiary’s Currency.
                            Enter The Sender And Receiver’s Information.
                            Choose A Method Of Delivery.
                            Submit The Form.
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                        <span>
                            02
                        </span>
                        <h3  i18n>Pay the amount to send</h3>
                        <p  i18n>Via Interac E-Transfer.
                            We're Integrated With All Canadian Banks For Free Interac E-Transfer.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".6s">
                        <span>
                            03
                        </span>
                        <h3  i18n>Receive the money</h3>
                        <p  i18n>Track Your Transaction Using The Code Provided.
                            Both You And Your Recipient Can Be Notified Of Funds Transfer.</p>
                    </div>
                </div>
            </div>
        </div>
    </div> -->



    <div class="accordion_area">
        <div class="container">
            <div class="row justify-content-end">
                <div class="col-lg-6">
                    <div class="faq_ask pl-68">
                        <h3  data-aos="fade-up" data-aos-offset="500" data-aos-duration="500"  i18n>Frequently ask</h3>
                        <div id="accordion">
                            <div class="card wow fadeInUp" data-wow-duration="1.1s" data-wow-delay=".3s">
                                <div class="card-header" id="headingOnee">
                                  <h5 class="mb-0">
                                    <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOnee" aria-expanded="true" aria-controls="collapseOnee"  i18n>
                                        What are acceptable ID documents for picking up money?
                                    </button>
                                  </h5>
                                </div>
                            
                                <div id="collapseOnee" class="collapse show" aria-labelledby="headingOnee" data-parent="#accordion">
                                  <div class="card-body"  i18n>
                                    In general passports and national IDs are acceptable.
                                  </div>
                                </div>
                              </div>
                                <div class="card wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s">
                                    <div class="card-header" id="headingOne">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"  i18n>
                                                How do I find out if my money has been sent?
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="">
                                        <div class="card-body"  i18n>Any time after sending, you will receive a link that allows you to check the status of your transaction.
                                        </div>
                                    </div>
                                </div>
                                <div class="card wow fadeInUp" data-wow-duration="1.3s" data-wow-delay=".5s">
                                    <div class="card-header" id="headingThree">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"  i18n>
                                                What rate do you use?
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion" style="">
                                        <div class="card-body"  i18n>We use the midmarket rates
                                        </div>
                                    </div>
                                </div>
                                <div class="card wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".6s">
                                    <div class="card-header" id="headingThree4">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4"  i18n>
                                                Is there any hidden fees?
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapseThree4" class="collapse" aria-labelledby="headingThree4" data-parent="#accordion" style="">
                                        <div class="card-body"  i18n>No, we're here to help the community and we do not plan to charge our customers.
                                        </div>
                                    </div>
                                </div>
                                <div class="card wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".6s">
                                    <div class="card-header" id="headingThree4">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4"  i18n>
                                                Which banks do you cover?
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapseThree4" class="collapse" aria-labelledby="headingThree4" data-parent="#accordion" style="">
                                        <div class="card-body"  i18n>We deposit money at all the major Cameroon banks.
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- testimonial_area  -->
    <div class="testimonial_area  ">
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="testmonial_active owl-carousel">
                        <div class="single_carousel">
                            <div class="row">
                                <div class="col-lg-11">
                                    <div class="single_testmonial d-flex align-items-center">
                                        <div class="thumb">
                                            <img src="./../../../assets/img/testmonial/author.png" alt="">
                                            <div class="quote_icon">
                                                <i class="Flaticon flaticon-quote"></i>
                                            </div>
                                        </div>
                                        <div class="info">
                                            <p  i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                            <span>- Micky Mouse</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single_carousel">
                            <div class="row">
                                <div class="col-lg-11">
                                    <div class="single_testmonial d-flex align-items-center">
                                        <div class="thumb">
                                            <img src="./../../../assets/img/testmonial/author.png" alt="">
                                            <div class="quote_icon">
                                                <i class=" Flaticon flaticon-quote"></i>
                                            </div>
                                        </div>
                                        <div class="info">
                                            <p  i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                            <span>- Micky Mouse</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="single_carousel">
                            <div class="row">
                                <div class="col-lg-11">
                                    <div class="single_testmonial d-flex align-items-center">
                                        <div class="thumb">
                                            <img src="./../../../assets/img/testmonial/author.png" alt="">
                                            <div class="quote_icon">
                                                <i class="Flaticon flaticon-quote"></i>
                                            </div>
                                        </div>
                                        <div class="info">
                                            <p  i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                            <span>- Micky Mouse</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /testimonial_area  -->

    <div class="apply_loan overlay">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-7">
                    <div class="loan_text wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                        <h3  i18n>Create your account and, 
                            make a transaction</h3>
                    </div>
                </div>
                <div class="col-lg-4 col-md-5">
                    <div class="loan_btn wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s">
                        <a class="boxed-btn3 submitZoom" (click)="openModalCreerCompte(template1)"  i18n>Create</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
   
      <!-- connexionRequired -->
      <ng-template #templateConnexionRequired>

        <div class="modal-header" style="background-color: #FFD700;">
      
          <h4 class="modal-title pull-left d-block d-sm-none" style="font-size: 10px !important;"  i18n>Connexion Required</h4>
          <h4 class="modal-title pull-left d-none d-sm-block"  i18n>Connexion Required</h4>
          <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
      
        <a class="modal-body" href="" id="loginFirst" (click)="openModalCreerCompte(template)"  i18n>
            please login first
        </a>

        <div class="modal-footer">
            <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()"  i18n>Close</a>
        </div>
       
      
      </ng-template>
      <!-- / connexionRequired  -->


      <!-- Creation de compte -->
<ng-template #template1>

    <div class="modal-header" style="background-color: #FFD700;">
  
      <h4 class="modal-title pull-left" style="font-size: 10px !important;"  i18n>Create account</h4>
      <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  
    <div class="modal-body">
      <form id="myForm">
        <div class="row">
          <div class="col">
            <input type="text" class="form-control inputSize" id="Inputprenom" #Inputprenom placeholder="First name">
            <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enablePrenom" style="color: red;"  i18n>First name required please !</div>
          </div>
          <div class="col"> 
            <input type="text" class="form-control inputSize" id="Inputnom" #Inputnom placeholder="Name">
            <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableNom"  style="color: red;"  i18n>Name required please !</div>
          </div>
        </div>
      <div class="form-group ">
          <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPrenom1"  i18n>Date of Birth</label></div>
          <div class="input-group date" data-provide="datepicker">
            <input type="date" class="form-control inputSize" id="Inputdate" #Inputdate aria-describedby="dateHelp" placeholder="Entrer date" required>   
          </div>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableDate"  style="color: red;"  i18n>Date required please !</div>
      </div>

      <div class="row">
        <div class="col">
          <input type="text" class="form-control inputSize" id="InputCountry" #InputCountry placeholder="Country">
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableCountry"  style="color: red;"  i18n>Country required please !</div>
        </div>
        <div class="col">
          <input type="text" class="form-control inputSize" id="InputTown" #InputTown placeholder="City">
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableTown"  style="color: red;"  i18n>City required please !</div>
        </div>
        <div class="col">
          <input type="text" class="form-control inputSize" id="InputProvince" #InputProvince placeholder="Province">
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableProvince"  style="color: red;"  i18n>Province required please !</div>
        </div>
      </div>
        <div class="form-group ">
          <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPrenom1"  i18n>Adresse</label></div>
          <input type="adress" class="form-control inputSize" id="Inputadress" #Inputadress aria-describedby="adresseHelp" placeholder="Entrer adresse" required>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableAdresse"  style="color: red;"  i18n>Address required please !</div>
      </div> 

      <div class="form-group ">
        <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPrenom1"  i18n>Phone</label></div>
      
        <div class="row">
            <div class="col">
    
                <select name="selectId" class="form-control" id="selectId" (change)="selectElement($event)">
                  <option value="0" label="Select a country ... " selected="selected">Select a country ... </option>
                  <optgroup id="country-optgroup-Africa" label="Africa">
                      <option value="CM" label="Cameroon"> Cameroon</option>
                      <option value="CI" label="Côte d’Ivoire">Côte d’Ivoire</option>
                  </optgroup>
                  <optgroup id="country-optgroup-Americas" label="Americas">
                      <option value="CA" label="Canada">Canada</option>
                      <option value="US">United States</option>
                  </optgroup>
                  <optgroup id="country-optgroup-Asia" label="Asia">
                      <option value="CN" label="China">China</option>
                  </optgroup>
                  <optgroup id="country-optgroup-Europe" label="Europe">    
                      <option value="FR" label="France">France</option>
                      <option value="GB" label="United Kingdom">United Kingdom</option>
                  </optgroup>
                </select>
    
            </div>
            <div class="col">
              <input type="tel" id="InputTel" class="form-control inputSize" #InputTel placeholder="Phone">
            </div>
          </div>

        <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableTelephone"  style="color: red;"  i18n>phone -- required please !</div>
      </div> 
        <div class="form-group ">
          <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputEmail1"  i18n>Email address</label></div>
          <input type="email" class="form-control inputSize" id="Inputemail" #Inputemail aria-describedby="emailHelp" placeholder="Enter email" required>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableEmail"  style="color: red;"  i18n>Email required please !</div>
        </div>
        <div class="form-group ">
          <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPassword1"  i18n>Password</label></div>
          <input type="password" class="form-control inputSize" id="Inputpassword" #Inputpassword placeholder="Password" required>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enablePassword"  style="color: red;"  i18n>Password required please !</div>
        </div>
        <div class="form-group">
          <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPassword1"  i18n>Confirm password</label></div>
          <input type="password" class="form-control inputSize" id="InputConfirmPassword" #InputConfirmPassword placeholder="Confirm password" required>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableConfirmPassword"  style="color: red;"  i18n>Password required please !</div>
          <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enablePasswordMatch"  style="color: red;"  i18n>Passwords do not match</div>
        </div>
        <div class="form-group form-check">
            <a  (click)="openModalCreerCompte(template)"  i18n>Already a member ? open a session</a>
          </div>
      </form>
    </div>
  
    <div class="modal-footer">
      <button type="submit" value="Verify" class="boxed-btn4-xs h-15 "  (click)="creerCompte(Inputnom,Inputprenom,Inputdate,InputCountry,InputProvince,InputTown,Inputadress,Inputemail,Inputpassword,InputConfirmPassword,InputTel)"  >Create</button>
      <button type="button" class="boxed-btn4-red-xs pull-rigth " (click)="modalRef.hide()"  i18n>Close</button>
    </div>
  
  </ng-template>
  <!-- / creation de compte -->

  <!-- logOut -->
<ng-template #templateLogout>

    <div class="modal-header" style="background-color: #FFD700;">
  
      <h4 class="modal-title pull-left d-block d-sm-none" style="font-size: 10px !important;"  i18n>Logout</h4>
      <h4 class="modal-title pull-left d-none d-sm-block"  i18n>Logout</h4>
      <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  
    <div class="modal-body">
       <p  i18n>Do you really want to Logout ?</p>
    </div>
  
    <div class="modal-footer">
  
        <a class="boxed-btn4-xs pull-left h-15" (click)="logOut()" i18n>Yes</a>
        <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()"  i18n>No</a>
    </div>
  
  </ng-template>
  <!-- / logOut  -->

   <!-- logOut -->
<ng-template #templateNobeneficiary>

    <div class="modal-header" style="background-color: #FFD700;">
  
      <h4 class="modal-title pull-left d-block d-sm-none" style="font-size: 10px !important;"  i18n>Add beneficiary</h4>
      <h4 class="modal-title pull-left d-none d-sm-block"  i18n>Add beneficiary</h4>
      <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  
    <div class="modal-body">
       <p  i18n>You don't have beneficiary !  click <strong>yes</strong> to create it </p>
    </div>
  
    <div class="modal-footer">
  
        <a class="boxed-btn4-xs pull-left h-15" (click)="beneficiaire()"  i18n>Yes</a>
        <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()"  i18n>No</a>
    </div>
  
  </ng-template>
  <!-- / logOut  -->

      <!-- Authentification -->
      <ng-template #template>

        <div class="modal-header" style="background-color: #FFD700;">
      
          <h4 class="modal-title pull-left" style="font-size: 10px !important;"  i18n>Authentification</h4>
          <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
      
        <div class="modal-body">
          <form>
            <div class="form-group">
              <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputEmail1"  i18n>Email address</label></div>
              <input type="email" class="form-control inputSize" id="exampleInputEmail1" #InputEmail aria-describedby="emailHelp" placeholder="Enter email" required>
              <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableEmail"  style="color: red;"  i18n>Email required please !</div>
              <small id="emailHelp" class="form-text text-muted"  i18n>We'll never share your email with anyone else.</small>
            </div>
            <div class="form-group">
              <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPassword1"  i18n>Password</label></div>
              <input type="password" class="form-control inputSize" id="exampleInputPassword1" #InputPassword placeholder="Password" required>
              <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enablePassword"  style="color: red;"  i18n>Password required please !</div>
            </div>
            <div class="form-group form-check">
              <a  class="text-danger" (click)="openModal(templateReset)"  i18n>Forgot password ?</a>
            </div>
            <div class="form-group form-check">
              <a  (click)="openModalCreerCompte(template1)" i18n>Not a member yet ? create an account</a>
            </div>   
          </form>
        </div>
      
        <div class="modal-footer">
          <a class="boxed-btn4-xs h-15" (click)="authentification(InputEmail,InputPassword)"  i18n>open</a>
        <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()"  i18n>Close</a>
        </div>
      
      </ng-template>
      <!-- / Authentification  -->

<!-- reset password -->
<ng-template #templateReset>

    <div class="modal-header" style="background-color: #FFD700;">
  
      <h4 class="modal-title pull-left" style="font-size: 10px !important;"  i18n>Reset password</h4>
      <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  
    <div class="modal-body">
      <div class="form-group">
        <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputEmail1" i18n>Email address</label></div>
        <input type="email" class="form-control inputSize" id="exampleInputEmail1" #Inputemail aria-describedby="emailHelp" placeholder="Enter email" required>
        <div data-aos="fade-right" data-aos-duration="1500" *ngIf="enableEmail"  style="color: red;"  i18n>Email required please !</div>
        <small id="emailHelp" class="form-text text-muted"  i18n>We'll never share your email with anyone else.</small>
      </div>
    </div>
  
    <div class="modal-footer">
  
        <a class="boxed-btn4-xs pull-left h-15" (click)="forgotPassword(Inputemail)" i18n>Send</a>
        <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()"  i18n>Cancel</a>
    </div>
  
  </ng-template>
<!-- / reset password  -->